import React, { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';

import { PaymentScheduleModal } from 'V2/Shared/PaymentScheduleModal';
import { PaymentPlanType } from 'V2/Types/Payment';

type PaymentScheduleModalProps = {
  show: boolean;
  paymentPlan: PaymentPlanType | null;
  onClose?: () => void;
};

type ShowModalProps = {
  paymentPlan: PaymentPlanType;
  onClose: () => void;
};

export const usePaymentScheduleModal = () => {
  const [modalState, setModalState] = useState<PaymentScheduleModalProps>({
    show: false,
    paymentPlan: null,
    onClose: () => {},
  });

  const showPaymentScheduleModal = useCallback((params: ShowModalProps) => {
    return new Promise((resolve) => {
      setModalState({
        show: true,
        paymentPlan: params.paymentPlan,
        onClose: () => {
          params.onClose();
          resolve(null);
        },
      });
    });
  }, []);

  const closePaymentScheduleModal = useCallback(() => {
    setModalState({
      show: false,
      paymentPlan: null,
      onClose: () => {},
    });
  }, []);

  const modalComponent = modalState.show
    ? createPortal(
        <PaymentScheduleModal
          show={modalState.show}
          onClose={modalState.onClose || closePaymentScheduleModal}
          paymentPlan={modalState.paymentPlan!}
        />,
        document.body
      )
    : null;

  return {
    showPaymentScheduleModal,
    closePaymentScheduleModal,
    PaymentScheduleModal: modalComponent,
  };
};
